import { PureComponent } from 'react';
import { OLAF } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { CRM_FULL_WIDTH } from '../../crm-sidebar/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Icon = styled(UIIcon).withConfig({
  displayName: "ContactSidebarAsyncError__Icon",
  componentId: "sc-1g45hzd-0"
})(["width:30px;text-align:center;"]);
const Wrapper = styled.div.withConfig({
  displayName: "ContactSidebarAsyncError__Wrapper",
  componentId: "sc-1g45hzd-1"
})(["height:100%;background-color:", ";position:absolute;right:0;width:", "px;overflow-y:auto;"], OLAF, CRM_FULL_WIDTH);
const PaddingWrapper = styled.div.withConfig({
  displayName: "ContactSidebarAsyncError__PaddingWrapper",
  componentId: "sc-1g45hzd-2"
})(["padding:0 20px;display:flex;align-items:center;flex-direction:column;flex-grow:1;flex-shrink:0;flex-basis:100%;"]);
export default class ContactSidebarAsyncError extends PureComponent {
  renderCollapsedContent() {
    return /*#__PURE__*/_jsx(Icon, {
      name: "warning"
    });
  }
  render() {
    const {
      retry
    } = this.props;
    return /*#__PURE__*/_jsx(Wrapper, {
      children: /*#__PURE__*/_jsx(PaddingWrapper, {
        children: /*#__PURE__*/_jsxs(UIErrorMessage, {
          title: I18n.text('conversations-inbox-ui.contactLoadingError.title'),
          illustrationProps: {
            width: '100'
          },
          children: [/*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "conversations-inbox-ui.contactLoadingError.message"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            use: "tertiary",
            size: "xs",
            onClick: retry,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "conversations-inbox-ui.contactLoadingError.retryButtonLabel"
            })
          })]
        })
      })
    });
  }
}
ContactSidebarAsyncError.displayName = 'ContactSidebarAsyncError';